<template>
    <div>
        <loading :active.sync="loading.content" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                <!-- <router-link :to="{name:'home'}" class="headerButton"> -->
                    <ion-icon name="chevron-back-outline"></ion-icon>
                <!-- </router-link> -->
                </a>
            </div>
            <div class="pageTitle">{{ title }}</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group basic">
                        <label class="label" v-if="data.operator_label_input == null">No. Pengisian</label>
                        <label class="label" v-else>{{data.operator_label_input}}</label>
                        <div class="input-group">
                            <input type="tel" class="form-control form-control-lg" v-model="data.destination" @input="getPrefix">
                            <div class="input-group-append" v-if="data.operator_id == 7">
                                <ButtonLoader :loading="loading.button_check_pln" :styled="'btn btn-primary btn-sm rounded pl-2 pr-2'" @click.native="checkPLN()">Cek</ButtonLoader>
                            </div>
                        </div>
                    
                        <div class="mt-2">
                            <div class="chip chip-media" style="font-size:11px;background:#efefef;" @click="openPhoneBook()">
                                <i class="chip-icon bg-primary">
                                    <ion-icon name="journal-outline"></ion-icon>
                                </i>
                                <span class="chip-label">Buku Telepon</span>
                            </div>
                            <div class="chip chip-media ml-1" style="font-size:11px;background:#efefef;" @click="phone(customer.phone)">
                                <i class="chip-icon bg-primary">
                                    <ion-icon name="call-outline"></ion-icon>
                                </i>
                                <span class="chip-label">{{ customer.phone }}</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- <div class="section full mt-1">
                <ul class="listview image-listview inset">
                    <li v-if="withPrefix == 1">
                        <a class="item" @click="phone(customer.phone)" style="cursor: pointer">
                            <div class="icon-box bg-primary">
                                <ion-icon name="call-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>{{ customer.phone }}</div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a id="importContact" class="item" style="cursor: pointer" @click="openPhoneBook()">
                            <div class="icon-box bg-primary">
                                <ion-icon name="journal-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>Ambil dari kontak</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div> -->
            <div class="section full mt-1" v-if="operator.length > 0">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item">
                            <img v-if="data.operator_icon != '' && data.operator_icon != null" :src="data.operator_icon != '' ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/operator/'+data.operator_icon:''" alt="image" class="image">
                            <div class="in">
                                <div>
                                    <header>{{ title }}</header>
                                    <b>{{ data.operator_name }}</b>
                                </div>
                                <span class="text-muted">
                                    <button class="btn btn-primary btn-sm pl-3 pr-3 " style="font-size:9px;font-weight:normal;height:25px;" @click="modalOperator('show')">Pilih</button>
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="section inset mt-1" v-if="data_pln.nama_pelanggan != '' && data_pln.tarif_daya != ''">
                <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                    <div class="content-header mb-1">Detail No. Pelanggan</div>
                    <div class="row">
                        <div class="col-6">Nama</div>
                        <div class="col-6"><b>{{ data_pln.nama_pelanggan }}</b></div>
                    </div>
                    <div class="row">
                        <div class="col-6">Tarif/Daya</div>
                        <div class="col-6"><b>{{ data_pln.tarif_daya }}</b></div>
                    </div>
                </div>
            </div>
            <div class="section full mt-1" v-if="operator.length > 0">
                <div v-if="loading.content == false">
                    <div v-if="product.length > 0">
                        <ul class="listview image-listview-product inset">
                            <li v-for="item in product" :key="item.id">
                                <a class="item pl-2 pr-2" v-if="item.status == 'ACTIVE'" @click="showDetail(item)">
                                    <div class="in">
                                        <div style="width: 90%;">
                                            <h4>{{ item.product_name }}</h4>
                                            <footer v-if="item.description != null">{{ item.description }}</footer>
                                        </div>
                                        <span class="text-muted">
                                            <div class="chip chip-primary ml-05 mb-05">
                                                <span class="chip-label">Rp {{ item.price | rupiah }}</span>
                                            </div>
                                        </span>
                                    </div>
                                </a>
                                <div class="item pl-2 pr-2" disabled v-else>
                                    <div class="in">
                                        <div style="width: 90%;">
                                            <h4 class="text-secondary">{{ item.product_name }}</h4>
                                            <footer class="text-secondary" v-if="item.description != null">{{ item.description }}</footer>
                                        </div>
                                        <span class="text-muted">
                                            <div class="chip chip-secondary ml-05 mb-05">
                                                <span class="chip-label text-secondary">Rp {{ item.price | rupiah }}</span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- * Form -->
        </div>

        <action-sheet ref="operator" :title="'Pilih Produk'" :inset="false" :content-full="true"> 
            <ul class="listview image-listview">
                <li v-for="item in operator" :key="item.id">
                    <a style="cursor:pointer;" class="item" @click="selectOperator(item)">
                        <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/operator/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="image">
                        <div class="in">
                            <div>{{ item.product_name }}</div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>

        <action-sheet ref="modalDetailProduct" :title="'Detail Produk'" :header="false" :inset="false" :content-height="true"> 
            <div style="border-bottom:1px dashed #dee2e6;">
                <h4 style="margin-bottom:0px;">{{ data.product_name }}</h4>
                <label class="label text-primary" style="font-size:13px;">Rp {{ data.price | rupiah }}</label>
            </div>
            <div class="pt-2" style="border-bottom:1px dashed #dee2e6;line-height:1.3" v-if="data.full_description">
                <div style="font-size:11px;" v-html="data.full_description"></div>
            </div>
            <div class="form-group basic mt-1 pb-0">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-outline-primary btn-block btn-lg" style="height:40px;border-width:1px;" @click="hideDetail()">Nanti</button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block btn-lg" style="height:40px;" @click="showConfirm(product_select)">Beli</button>
                    </div>
                </div>
            </div>
        </action-sheet>

        <action-sheet ref="modalConfirmation" :title="'Konfirmasi Pembelian'" :header="true" :inset="false" :content-height="true"> 
            <div style="border-bottom:1px dashed #dee2e6;">
                <h4 style="margin-bottom:0px;">{{ data.product_name }}</h4>
                <label class="label text-primary" style="font-size:13px;">Rp {{ data.price | rupiah }}</label>
            </div>
            <div class="mb-1 mt-1 pb-1" style="border-bottom:1px dashed #dee2e6;">
                <table class="w-100" style="font-size:12px;line-height:1.2rem">
                    <tr>
                        <td>Produk</td>
                        <td style="text-align:right;">{{ title }}</td>
                    </tr>
                    <tr>
                        <td>No. Pengisian</td>
                        <td style="text-align:right;">{{ data.destination }}</td>
                    </tr>
                    <tr>
                        <td>Cashback (Premium)</td>
                        <td style="text-align:right;">Rp {{ data.cashback | rupiah }}</td>
                    </tr>
                    
                </table>
            </div>
            <div class="mb-1 mt-1 pb-1" style="border-bottom:1px dashed #dee2e6;">
                <table class="w-100" style="font-size:12px;line-height:1.5rem">
                    <tr>
                        <td>Atur Harga Jual</td>
                        <td width="40%"><input type="tel" class="form-control form-control-sm text-center p-0" v-model="data.price_selling" @input="inputPriceSelling"></td>
                    </tr>
                </table>
            </div>
            <div class="form-group boxed" v-if="customer.pin_trx == 'ENABLED'">
                <label class="label text-center">Masukkan PIN</label>
                <input type="number" pattern="[0-9]*" inputmode="numeric" class="form-control form-control-lg text-center p-0 input-password" style="letter-spacing: 0.7em" maxlength="6" v-model="data.pin" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
            </div> 
            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-outline-primary btn-block btn-lg" style="height:40px;border-width:1px;" @click="hideConfirm()">Batal</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="loading.button_submit" :styled="'btn btn-primary btn-block btn-lg'" style="height:40px;" @click.native="submit()">Beli</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>

        <action-sheet ref="status" :title="'Status Pembelian'" :inset="true"> 
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Sedang diproses</h3>
                <p>Pembelian Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <a class="btn btn-primary btn-block btn-lg" :href="'https://play.google.com/store/apps/details?id='+VUE_ENV.VUE_APP_PACKAGENAME_APK" target="_blank">Review di Playstore</a>
                <button class="btn btn-outline-primary btn-block btn-lg" @click="hideStatus">Tutup</button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../api.js'
import { mapState } from 'vuex'
export default {
    props: ['title','withPrefix','redirect'],
    data() {
        return {
            loading:{
                button_submit: false,
                button_check_pln: false,
                content: true
            },
            list_price_selling: [],
            operator: [],
            product: [],
            product_select: {},
            data:{
                operator_id: '',
                operator_name: '',
                operator_icon: '',
                operator_description: '',
                operator_type_input: '',
                operator_label_input: '',
                operator_description_input: '',
                product_id: '',
                product_name: '',
                destination: '',
                price: '',
                cashback: '',
                price_selling: '',
                description: '',
                full_description: '',
                pin: '',
            },
            data_pln:{
                nama_pelanggan: '',
                tarif_daya: ''
            },
            time: null
        }

        
    },
    created(){
        if(this.withPrefix == 0){
            this.getOperator()
        }else{
            this.loading.content = false
        }
        window.fbq('track', 'ViewContent');
    },
    computed: {
        ...mapState(['customer','toast','VUE_ENV','device']),
        filterPriceSelling(){
            return this.list_price_selling.filter(item => item.product_id === this.data.product_id);
        }
    },
    methods:{
        inAppReview(){
            if (typeof window.AndroidNative !== 'undefined') {
                window.AndroidNative.inAppReview();
            }
        },
        phone(phone){
            this.data.destination = this.$options.filters.filterPhone(this.$options.filters.filterPhone(phone.substring(0,3), ['+62', '62'], ['0', '0']) + phone.substring(20,3), ['-'], [''])
            if(this.withPrefix == 1){
                this.getPrefix()
            }
        },
        modalOperator(value){
            if(this.$refs.operator != undefined){
                let element = this.$refs.operator.$el
                window.$(element).modal(value)
            }
        },
        selectOperator(data){
            this.data.operator_id = data.id
            this.data.operator_name = data.product_name
            this.data.operator_description = data.description
            this.data.operator_icon = data.icon
            this.data.operator_type_input = data.type_input
            this.data.operator_label_input = data.label_input
            this.data.operator_description_input = data.description_input
            this.getProduct()
            this.modalOperator('hide')
        },
        showDetail(item){
            this.$store.commit('RESET_TOAST')
            if(item.full_description){
                this.product_select = item
                this.data.product_name = item.product_name
                this.data.price = item.price
                this.data.full_description = item.full_description
                let element = this.$refs.modalDetailProduct.$el
                window.$(element).modal('show')
            }else{
                this.showConfirm(item)
            }
        },
        hideDetail(){
            let element = this.$refs.modalDetailProduct.$el
            window.$(element).modal('hide')
        },
        showConfirm(item){
            this.hideDetail()
            this.data.pin = ''
            this.$store.commit('RESET_TOAST')
            if(this.data.destination != ''){
                this.data.product_id = item.product_id
                this.data.product_name = item.product_name
                this.data.price = item.price
                this.data.cashback = item.cashback
                this.data.description = item.description
                this.data.full_description = item.full_description

                if(this.filterPriceSelling.length > 0){
                    this.data.price_selling = this.$options.filters.inputRupiah(this.filterPriceSelling[0].price_selling)
                }else{
                    this.data.price_selling = this.$options.filters.inputRupiah(item.price)
                }

                let element = this.$refs.modalConfirmation.$el
                window.$(element).modal('show')
            }else{
                this.$store.commit('SET_TOAST', {show:true,message:'No. Pengisian tidak boleh kosong',tipe:'default'})
            }
        },
        hideConfirm(){
            this.data.pin = ''
            let element = this.$refs.modalConfirmation.$el
            window.$(element).modal('hide')
        },
        showStatus(){
            let element = this.$refs.status.$el
            window.$(element).modal('show')
        },
        hideStatus(){
            let element = this.$refs.status.$el
            window.$(element).modal('hide')
            this.inAppReview()
        },
        getPrefix(){
            this.$store.commit('RESET_TOAST')
            this.data_pln = {
                nama_pelanggan: '',
                tarif_daya: ''
            }
            if(this.withPrefix == 1){
                this.data.destination = this.$options.filters.filterPhone(this.$options.filters.filterPhone(this.data.destination.substring(0,3), ['+62', '62'], ['0', '0']) + this.data.destination.substring(20,3), ['-'], [''])
                if(this.data.destination.length >= 4){
                    if(this.time){
                        clearTimeout(this.time)
                    }
                    this.time = setTimeout(() => {
                        this.loading.content = true
                        this.getOperator()
                    }, 500)
                }else{
                    this.data = {
                        destination: this.data.destination,
                        operator_id: '',
                        operator_icon: '',
                        operator_description: '',
                        product_id: '',
                        product_name: '',
                        price: '',
                    },
                    this.operator = []
                    this.product = []
                }
            }
        },
        getOperator(){
            $axios.post('/prabayar/operator', {category_id:this.$route.params.id,prefix:this.data.destination.substring(0,4)})
            .then((response) => {
                if(response.data.data.length > 0){
                    this.operator = response.data.data
                    this.data.operator_id = response.data.data[0].id
                    this.data.operator_name = response.data.data[0].product_name
                    this.data.operator_description = response.data.data[0].description
                    this.data.operator_icon = response.data.data[0].icon
                    this.data.operator_type_input = response.data.data[0].type_input
                    this.data.operator_label_input = response.data.data[0].label_input
                    this.data.operator_description_input = response.data.data[0].description_input

                    if(this.redirect != undefined){
                        this.selectOperator(this.redirect)
                    }else{
                        this.getProduct()
                    }
                }else{
                    this.operator = []
                    this.product = []
                    this.$store.commit('SET_TOAST', {show:true,message:'Produk belum tersedia',tipe:'default'})
                    this.loading.content = false
                }
            }).catch(e => {
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default'})
                this.loading.content = false
            })
        },
        getProduct(){
            this.loading.content = true
            this.$store.commit('RESET_TOAST')
            $axios.post('/prabayar/product', {operator_id:this.data.operator_id})
            .then((response) => {
                if(response.data.data.length > 0){
                    this.product = response.data.data
                }else{
                    this.product = []
                    this.$store.commit('SET_TOAST', {show:true,message:'Produk belum tersedia',tipe:'default'})
                }
                this.loading.content = false
            })
        },
        checkPLN(){
            this.$store.commit('RESET_TOAST')
            this.data_pln = {
                nama_pelanggan: '',
                tarif_daya: ''
            }
            if(this.data.destination != ''){
                this.loading.button_check_pln = true
                $axios.post('/prabayar/inquiry-pln', {no_pelanggan:this.data.destination})
                .then((response) => {
                    this.data_pln.nama_pelanggan = response.data.data.nama_pelanggan
                    this.data_pln.tarif_daya = response.data.data.tarif_daya
                    this.loading.button_check_pln = false
                }).catch(e => {
                    this.loading.button_check_pln = false
                    this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default'})
                })
            }else{
                this.$store.commit('SET_TOAST', {show:true,message:'No. Pengisian tidak boleh kosong',tipe:'default'})
            }
        },
        submit(){
            this.loading.button_submit = true
            this.addPriceSelling()
            $axios.post('/prabayar/order', {destination:this.data.destination,product_id:this.data.product_id,pin:this.data.pin,price_selling:this.data.price_selling.replace(/[^,\d]/g, '')})
            .then(() => {
                this.loading.button_submit = false
                if(this.withPrefix == 1){
                    this.data =  {
                        destination: '',
                        operator_id: '',
                        operator_icon: '',
                        product_id: '',
                        product_name: '',
                        price: '',
                    }
                    this.operator = []
                    this.product = []
                }else{
                    this.data.destination = ''
                }
                this.hideConfirm()
                this.showStatus()
            }).catch(e => {
                this.loading.button_submit = false
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default'})
                this.hideConfirm()
            })
        },
        openPhoneBook(){
            if (typeof window.AndroidNative !== 'undefined') {
                window.AndroidNative.openPhoneBook();
            }
        },
        
        inputPriceSelling(){
            this.data.price_selling = this.$options.filters.inputRupiah(this.data.price_selling)
        },
        addPriceSelling(){
            const price = this.data.price
            const price_selling = this.data.price_selling.replace(/[^,\d]/g, '')
            if(price_selling != price){
                if(this.filterPriceSelling[0] == null){
                    this.list_price_selling.push({product_id:this.data.product_id,price_selling:price_selling.replace(/[^,\d]/g, '')})
                }
                this.savePriceSelling()
            }
        },
        savePriceSelling(){
            this.$set(this.list_price_selling, this.list_price_selling.findIndex(f => f.product_id === this.data.product_id), {product_id: this.data.product_id, price_selling: this.data.price_selling.replace(/[^,\d]/g, '')})
            const parsed = JSON.stringify(this.list_price_selling);
            localStorage.setItem('price_selling', parsed);
        }
    },
    mounted() {
        if(this.title == undefined && this.withPrefix == undefined){
            this.$router.push({name:'home'})
        }
        if (localStorage.getItem('price_selling')) {
            try {
                this.list_price_selling = JSON.parse(localStorage.getItem('price_selling'));
            } catch(e) {
                localStorage.removeItem('price_selling');
            }
        }
        
        window["phone"] = (phone) => {
            this.phone(phone);
        };
        
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
    filters:{
        filterPhone: function(value, findArray, replaceArray){
            var i, regex = [], map = {}; 
            for( i=0; i<findArray.length; i++ ){ 
                regex.push( findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g,'\\$1') );
                map[findArray[i]] = replaceArray[i]; 
            }
            regex = regex.join('|');
            var destination = value.replace( new RegExp( regex, 'g' ), function(matched){
                return map[matched];
            });
            return destination.replace(/ /g, "");
        },
        inputRupiah: function(value){
            value = value.toString()
            var number_string = value.replace(/[^,\d]/g, '').toString(),
            split   		= number_string.split(','),
            sisa     		= split[0].length % 3,
            rupiah     		= split[0].substr(0, sisa),
            ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            return rupiah
        },
    }
}
</script>